import axios from 'axios';
import * as actionTypes from '../actions/types';

const baseUrl = process.env.NODE_ENV === 'development' ? 
    process.env.REACT_APP_DEV_API_BASE_URL : process.env.REACT_APP_PROD_API_BASE_URL;

export const authSuccess = (user, isVerifying) => {
    return {type: actionTypes.AUTH_SUCCESS, user: user, isVerifying: isVerifying};
}

export const authFail = error => {
    return {type: actionTypes.AUTH_FAIL, error: error};
}

export const logout = () => dispatch => {
    localStorage.removeItem('user');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('preferences');
    dispatch({type: actionTypes.AUTH_LOGOUT});
}

export const authLogin = user => async dispatch => {
    var authRes = await axios.post(`${baseUrl}/api/auth/login`, user);
    console.log(authRes);
    if (authRes.data.isSuccess) {
        const appUser = authRes.data.user;
        const expirationDate = new Date(new Date().getDate() + 14);
        localStorage.setItem('user', appUser);
        localStorage.setItem('expirationDate', JSON.stringify(expirationDate));
        dispatch(authSuccess(appUser,false));
    } else {
        dispatch(authFail(authRes.data.message));
    }
                    
    await axios.get(`${baseUrl}/api/profiles/currentuser?id=${authRes.data.user}`)
        .then(res => {
            if (res.data.isSuccess) {
                localStorage.setItem('userProfile', JSON.stringify(res.data.userProfile));
                dispatch({ type: actionTypes.SUCCESS_FETCH_USER_PROFILE, payload: res.data.userProfile});
            }
        })
        .catch(err => {
            dispatch({type: actionTypes.ERROR_FETCH_USER_PROFILE, errors: err.statusText});
        })
}

export const authRegister = user => async (dispatch) => {
    await axios.post(`${baseUrl}/api/auth/register`, user)
        .then(() => {
            dispatch(authSuccess(null, true));
        })
        .catch(err => {
            dispatch(authFail(err));
        })
}

export const authChangePassword = (id, newPassword) => async dispatch => {
    var data = { id, newPassword };
    await axios.post(`${baseUrl}/api/auth/changepassword`, data)
        .then(() => {
            dispatch({type: actionTypes.AUTH_CHANGE_PASSWORD});
        })
        .catch(() => {
            dispatch({type: actionTypes.AUTH_CHANGE_PASSWORD, error: 'Couldnt change password'});
        });
}

export const authForgotPassword = (email, newPassword) => async dispatch => {
    var data = { email, newPassword };
    await axios.post(`${baseUrl}/api/auth/forgotpassword`, data)
        .then(() => {
            dispatch({type: actionTypes.AUTH_CHANGE_PASSWORD});
        })
        .catch(() => {
            dispatch({type: actionTypes.AUTH_CHANGE_PASSWORD, error: 'Couldnt change password'});
        });
} 

export const authCheckState = () => dispatch => {
    const user = localStorage.getItem('user');
    if (user === undefined || user === null) {
        logout();
    } else {
        const expirationDate = new Date(localStorage.getItem('expirationDate'));
        const userProfile = JSON.parse(localStorage.getItem('userProfile'));
        if (new Date() > expirationDate) {
            logout();
        } else if (userProfile === undefined || userProfile === null) {
            logout();
        }
        else{
            dispatch(authSuccess(user, false));
        }
    }
}